module.exports = __webpack_public_path__ + "img/buyafeature_select.2c1174d0.svg";